import { useEffect } from 'react';
import useShortcut from '../../labelling/providers/hooks/use-shortcut';
import { handleShortcutRegistrationError, SUPPORTED_KEYBOARD_EVENTS } from '../../labelling/providers/utils/shortcut';
import type { VideoPlayerControlTypesT } from '../../labelling/types';
import { VIDEO_PLAYER_CONTROL_TYPES } from '../components/frames-control-panel/constants';
type PlaybackShortcutsParamsT = {
  togglePlayback: (status: boolean) => void;
  isPlaying: boolean;
  isDisabled?: boolean;
  isMultiVideoIndex: boolean;
  handlePlaybackControlsClick: (controlType: VideoPlayerControlTypesT) => void;
};

// abstracted out from FrameControls component for readability
export function usePlaybackShortcuts({
  togglePlayback,
  isPlaying,
  isDisabled,
  isMultiVideoIndex,
  handlePlaybackControlsClick
}: PlaybackShortcutsParamsT) {
  const {
    registerHotKeys
  } = useShortcut();
  useEffect(() => {
    const {
      errors,
      removeHotKeys
    } = registerHotKeys([{
      type: SUPPORTED_KEYBOARD_EVENTS.KEYUP,
      keys: [' '],
      onAction: e => {
        e.preventDefault();
        togglePlayback(!isPlaying);
      }
    }, {
      keys: ['m'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.BACKWARD);
      }
    }, {
      keys: ['n'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.FORWARD);
      }
    }, {
      keys: ['Mod', 'ArrowLeft'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.SKIP_TO_FIRST);
      }
    }, {
      keys: ['Mod', 'ArrowRight'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.SKIP_TO_LAST);
      }
    }, {
      keys: ['Shift', 'ArrowLeft'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.JUMP_BACKWARD);
      }
    }, {
      keys: ['Shift', 'ArrowRight'],
      onAction: e => {
        e.preventDefault();
        if (isMultiVideoIndex) return;
        !isDisabled && handlePlaybackControlsClick(VIDEO_PLAYER_CONTROL_TYPES.JUMP_FORWARD);
      }
    }]);
    errors.forEach(error => handleShortcutRegistrationError(error));
    return () => {
      removeHotKeys();
    };
  }, [registerHotKeys, togglePlayback, isPlaying, isDisabled, handlePlaybackControlsClick, isMultiVideoIndex]);
}